import {
  CONFERENCIACUSTODIANTE_DATAS,
  CONFERENCIACUSTODIANTE_IGNORADA_DELETE,
  CONFERENCIACUSTODIANTE_IGNORADA_LIST,
  CONFERENCIACUSTODIANTE_IGNORADA_ADD,
  CONFERENCIACUSTODIANTE_DELETE,
  CONFERENCIACUSTODIANTE_ATIVOS
} from '../const/servicesURI';
import utils from '../utils';
import requestService from './requestService';

export const datas = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_DATAS, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Datas');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const ativos = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_ATIVOS, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Ativos');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const ignoradasList = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_IGNORADA_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Ignoradas Listar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const ignoradasAdd = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'post'
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_IGNORADA_ADD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Ignoradas Add');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const ignoradasRemove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'delete'
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_IGNORADA_DELETE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Ignoradas Excluir');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'delete'
  };

  return requestService(xProps, CONFERENCIACUSTODIANTE_DELETE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Conferência Custodiante Excluir');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const conferenciacustodiante = {
  datas,
  ativos,
  ignoradasList,
  ignoradasAdd,
  ignoradasRemove,
  remove
};

export default conferenciacustodiante;
